module.exports = __webpack_public_path__ + "img/vacunas2.b5613e13.jpg";